module.exports = __webpack_public_path__ + "img/cross.bec9d816.svg";